/*jshint esversion: 6 */
import Login from './components/public/Login';
import Register from './components/public/Register';
import Forgetpsw from './components/public/Forgetpsw';
import ResendMail from './components/public/ResendMail';
import Private from './components/private/layout/Layout';
import Main from './components/public/LoginContent';
import Maps from './components/private/pages/Maps';
import ProfileDetail from './components/private/pages/ProfileDetail';
import Changepsw from './components/private/pages/Changepsw';
import RegisterResult from './components/public/RegisterResult';
import Resetpsw from './components/public/Resetpsw';

export default [{
  path: '/',
  component: Login
}, {
  path: '/Register',
  component: Register
}, {
  path: '/RegisterResult',
  component: RegisterResult
}, {
  path: '/Forgetpsw',
  component: Forgetpsw
}, {
  path: '/ResendMail',
  component: ResendMail
}, {
  path: '/Resetpsw/:email',
  name: 'Resetpsw',
  component: Resetpsw
}, {
  path: '/Main',
  component: Private,
  children: [{
    path: 'Index',
    component: Main
  }, {
    path: 'Maps',
    component: Maps
  }, {
    path: 'Profile',
    component: ProfileDetail
  }, {
    path: 'Changepsw',
    component: Changepsw
  }]
}];



// WEBPACK FOOTER //
// ./src/router-config.js